import React from "react";

import { formatDecimalAbsolute } from "../../../../../utils";
import { ChangePill, OriginationTag, PillArrow } from "./styles";
import { ChangeIndicatorProps, RateChangeDirection } from "./types";

const ARROW: Record<RateChangeDirection, string> = {
  up: "▲",
  down: "▼",
  flat: "—",
};

export const ChangeIndicator: React.FC<ChangeIndicatorProps> = ({
  isOrigination,
  direction,
  deltaPp,
}) => {
  if (isOrigination || deltaPp === null) {
    return <OriginationTag>Origination</OriginationTag>;
  }

  return (
    <ChangePill $direction={direction} data-testid="rate-change-pill">
      <PillArrow aria-hidden>{ARROW[direction]}</PillArrow>
      {formatDecimalAbsolute(deltaPp, 3)} pp
    </ChangePill>
  );
};

ChangeIndicator.displayName = "ChangeIndicator";
